import React, { useState } from 'react';
import Topnavigation from './Topnavigation';
import Footer from './Footer';
import SEO from './SEO';

const coursesData = [
  {
    id: 'ssc',
    label: 'SSC',
    img: './assets/img/ssc.jpg',
    icon: '🎓',
    tagline: 'Foundation for Success',
    color: '#009999',
    description:
      'Our SSC coaching program is designed to build a strong academic foundation. With expert faculty and structured study material, students consistently achieve top results.',
    highlights: ['All Subjects Covered', 'Daily Practice Tests', 'Doubt Clearing Sessions', 'Study Material Provided'],
    batches: [
      { name: 'S.P. Batch (Study-Link Pattern)', time: 'Sunday to Sunday & Holidays – 3 to 4 hrs daily', start: '15th November' },
      { name: 'Regular Batch', time: 'Monday to Saturday – 2 hrs daily', start: '1st June' },
    ],
    subjects: ['Mathematics', 'Science', 'English', 'Hindi', 'Social Science', 'Sanskrit'],
  },
  {
    id: 'commerce',
    label: 'Commerce',
    img: './assets/img/ssc_1.jpg',
    icon: '📊',
    tagline: 'Master the Business World',
    color: '#e67e22',
    description:
      'Our Commerce coaching covers all core subjects with real-world examples and case studies. We prepare students for board exams and competitive entrance tests.',
    highlights: ['Expert Commerce Faculty', 'Case Study Based Learning', 'Board Exam Focus', 'Career Guidance'],
    batches: [
      { name: 'S.L.B. Batch (Serious Learner\'s Batch)', time: 'Sunday to Sunday & Holidays – 3 to 4 hrs daily', start: '1st December' },
      { name: 'Regular Batch', time: 'Monday to Saturday – 2 hrs daily', start: '1st June' },
    ],
    subjects: ['Accountancy', 'Business Studies', 'Economics', 'Mathematics', 'English', 'Hindi'],
  },
  {
    id: 'science',
    label: 'Science',
    img: './assets/img/ssc_2.jpg',
    icon: '🔬',
    tagline: 'Explore. Discover. Excel.',
    color: '#8e44ad',
    description:
      'Our Science program focuses on conceptual clarity with practical demonstrations. We cover PCB and PCM streams with dedicated subject experts.',
    highlights: ['PCM & PCB Streams', 'Lab-Based Learning', 'JEE / NEET Orientation', 'Weekly Mock Tests'],
    batches: [
      { name: 'Morning Batch', time: 'Daily 6 Hours – Morning', start: '15th April' },
      { name: 'Evening Batch', time: 'Daily 6 Hours – Evening', start: '15th April' },
    ],
    subjects: ['Physics', 'Chemistry', 'Biology', 'Mathematics', 'English', 'Hindi'],
  },
];

const Courses = () => {
  const [active, setActive] = useState('ssc');
  const course = coursesData.find(c => c.id === active);

  return (
    <>
      <Topnavigation />
      <SEO
        title="Courses - SSC, Commerce, Science, CBSE & Entrance Exam Coaching"
        description="Study-Link offers SSC, Commerce, Science, CBSE/ICSE school tutoring, B.Com, B.Sc and engineering/BCA entrance coaching in Sangam Nagar, Indore - 452006. Call +91 7999061255."
        keywords="SSC coaching indore, commerce coaching indore, science coaching indore, CBSE coaching indore, ICSE coaching indore, BCom coaching indore, engineering entrance indore, BCA entrance indore"
        url="/courses"
      />

      {/* Hero Banner */}
      <div style={{ position: 'relative' }}>
        <img
          src="./assets/img/courses_offered.jpg"
          alt="Courses"
          style={{ width: '100%', height: 'auto', maxHeight: 420, objectFit: 'cover' }}
        />
        <div style={{
          position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.6)',
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        }}>
          <h1 style={{ color: '#fff', fontWeight: 700, fontSize: 'clamp(26px, 5vw, 48px)', textAlign: 'center' }}>
            Our Courses
          </h1>
          <p style={{ color: '#ddd', fontSize: 'clamp(14px, 2vw, 18px)', textAlign: 'center', padding: '0 15px' }}>
            Quality education tailored for every student
          </p>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb" style={{ background: 'transparent', justifyContent: 'center', marginBottom: 0 }}>
              <li className="breadcrumb-item"><a href="/" style={{ color: '#009999' }}>Home</a></li>
              <li className="breadcrumb-item active" style={{ color: '#fff' }}>Courses</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Course Tabs */}
      <section style={{ background: '#f9f9f9', padding: '50px 0' }}>
        <div className="container">
          <div className="text-center mb-4">
            <h2 style={{ fontWeight: 700, color: '#333' }}>Choose Your Course</h2>
            <div style={{ width: 60, height: 3, background: '#009999', margin: '10px auto 0' }}></div>
          </div>

          {/* Tab Buttons */}
          <div className="d-flex justify-content-center flex-wrap mb-5" style={{ gap: 12 }}>
            {coursesData.map(c => (
              <button
                key={c.id}
                onClick={() => setActive(c.id)}
                style={{
                  padding: '10px 30px', borderRadius: 30, fontWeight: 600, fontSize: 15,
                  border: `2px solid ${c.color}`, cursor: 'pointer', transition: 'all 0.3s',
                  background: active === c.id ? c.color : '#fff',
                  color: active === c.id ? '#fff' : c.color,
                }}
              >
                {c.icon} {c.label}
              </button>
            ))}
          </div>

          {/* Course Detail */}
          <div className="row align-items-start" style={{ background: '#fff', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
            {/* Image */}
            <div className="col-12 col-md-5" style={{ padding: 0 }}>
              <img
                src={course.img}
                alt={course.label}
                style={{ width: '100%', height: '100%', minHeight: 300, objectFit: 'cover' }}
              />
            </div>

            {/* Info */}
            <div className="col-12 col-md-7" style={{ padding: '35px 30px' }}>
              <span style={{
                background: course.color, color: '#fff', borderRadius: 20,
                padding: '4px 14px', fontSize: 13, fontWeight: 600,
              }}>
                {course.icon} {course.label}
              </span>
              <h3 style={{ fontWeight: 700, marginTop: 14, color: '#333' }}>{course.tagline}</h3>
              <p style={{ color: '#666', lineHeight: 1.8, marginBottom: 20 }}>{course.description}</p>

              {/* Highlights */}
              <div className="row mb-3">
                {course.highlights.map((h, i) => (
                  <div key={i} className="col-12 col-sm-6 mb-2">
                    <span style={{ color: course.color, fontWeight: 700, marginRight: 6 }}>✔</span>
                    <span style={{ color: '#444', fontSize: 14 }}>{h}</span>
                  </div>
                ))}
              </div>

              {/* Subjects */}
              <h6 style={{ fontWeight: 700, color: '#333', marginBottom: 10 }}>Subjects Covered:</h6>
              <div className="d-flex flex-wrap mb-3" style={{ gap: 8 }}>
                {course.subjects.map((s, i) => (
                  <span key={i} style={{
                    background: '#f0f0f0', color: '#555', borderRadius: 20,
                    padding: '4px 14px', fontSize: 13,
                  }}>{s}</span>
                ))}
              </div>

              <a href="/contact-us" className="btn" style={{
                background: course.color, color: '#fff',
                padding: '10px 30px', borderRadius: 6, fontWeight: 600, fontSize: 15,
              }}>
                Enquire Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Batch Schedule */}
      <section style={{ background: '#fff', padding: '50px 0' }}>
        <div className="container">
          <div className="text-center mb-4">
            <h2 style={{ fontWeight: 700, color: '#333' }}>Batch Schedule — {course.label}</h2>
            <div style={{ width: 60, height: 3, background: course.color, margin: '10px auto 0' }}></div>
          </div>
          <div className="row justify-content-center">
            {course.batches.map((b, i) => (
              <div key={i} className="col-12 col-md-5 mb-4">
                <div style={{
                  border: `2px solid ${course.color}`, borderRadius: 10,
                  padding: '25px 20px', textAlign: 'center',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
                }}>
                  <div style={{ fontSize: 32, marginBottom: 10 }}>🗓️</div>
                  <h5 style={{ fontWeight: 700, color: course.color }}>{b.name}</h5>
                  <p style={{ color: '#555', marginBottom: 6 }}><strong>Timing:</strong> {b.time}</p>
                  <p style={{ color: '#555', marginBottom: 0 }}><strong>Starting:</strong> {b.start}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* All Courses Overview */}
      <section style={{ background: '#f9f9f9', padding: '50px 0' }}>
        <div className="container">
          <div className="text-center mb-4">
            <h2 style={{ fontWeight: 700, color: '#333' }}>All Courses at a Glance</h2>
            <div style={{ width: 60, height: 3, background: '#009999', margin: '10px auto 0' }}></div>
          </div>
          <div className="row">
            {coursesData.map((c, i) => (
              <div key={i} className="col-12 col-sm-6 col-lg-4 mb-4">
                <div
                  className="card h-100"
                  onClick={() => setActive(c.id)}
                  style={{
                    border: 'none', borderRadius: 10, overflow: 'hidden', cursor: 'pointer',
                    boxShadow: active === c.id ? `0 6px 24px ${c.color}44` : '0 4px 16px rgba(0,0,0,0.08)',
                    borderTop: `4px solid ${c.color}`,
                    transition: 'all 0.3s',
                  }}
                >
                  <img src={c.img} alt={c.label} style={{ width: '100%', height: 180, objectFit: 'cover' }} />
                  <div className="card-body">
                    <h5 style={{ fontWeight: 700, color: c.color }}>{c.icon} {c.label}</h5>
                    <p style={{ color: '#666', fontSize: 14, lineHeight: 1.7 }}>{c.description.slice(0, 100)}...</p>
                    <button
                      style={{
                        background: 'none', border: `1px solid ${c.color}`,
                        color: c.color, borderRadius: 20, padding: '5px 18px',
                        fontSize: 13, fontWeight: 600, cursor: 'pointer',
                      }}
                    >
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ background: '#009999', padding: '50px 0' }}>
        <div className="container text-center">
          <h3 style={{ color: '#fff', fontWeight: 700, marginBottom: 12 }}>Ready to Enroll?</h3>
          <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: 25, fontSize: 16 }}>
            Admissions are open. Secure your seat today!
          </p>
          <a href="/contact-us" className="btn" style={{
            background: '#fff', color: '#009999',
            padding: '12px 40px', borderRadius: 6,
            fontWeight: 700, fontSize: 16,
          }}>
            Apply Now
          </a>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Courses;
